// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__3QF_k","rectangleContainer":"Button_rectangleContainer__142Ow","rectangle":"Button_rectangle__10XDM"};